module.exports = __webpack_public_path__ + "static/img/bg_photo_back.425dce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/bg_photo_back.png
// module id = +CVO
// module chunks = 69